/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_No_TemplateInputs */

const cs_api_error_no_template = /** @type {(inputs: Api_Error_No_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro tuto akci není k dispozici žádná šablona.`)
};

const en_api_error_no_template = /** @type {(inputs: Api_Error_No_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No usable template is available for this action.`)
};

/**
* | output |
* | --- |
* | "No usable template is available for this action." |
*
* @param {Api_Error_No_TemplateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_no_template = /** @type {((inputs?: Api_Error_No_TemplateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_No_TemplateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_no_template(inputs)
	return cs_api_error_no_template(inputs)
});